import { createListenerMiddleware } from '@reduxjs/toolkit';
import { registerFeedbackListeners } from '../features/feedback/feedbackListener';
import { registerNotificationsListeners } from '../features/notifications/notificationsListeners';
import { registerOperatorListeners } from '../features/operator/operatorListeners';
import { registerOperatorRefreshListeners } from '../features/operator/operatorRefresh';
import { registerOperatorTasksListeners } from '../features/operatorTasks/operatorTasksListeners';
import { registerOperatorDispatchListeners } from '../features/operatorDispatch/operatorDispatchListeners';
import { registerOperatorKitsListeners } from '../features/operatorKits/operatorKitsListeners';
import { registerOperatorPackingListeners } from '../features/operatorPacking/operatorPackingListeners';
import { registerStockSyncListeners } from '../features/stockSync/stockSyncListeners';

/**
 * The store's one listener middleware: what happens in reaction to an action,
 * kept in Redux and out of the components.
 */
export const listenerMiddleware = createListenerMiddleware();

registerFeedbackListeners(listenerMiddleware.startListening);
registerNotificationsListeners(listenerMiddleware.startListening);
registerOperatorListeners(listenerMiddleware.startListening);
registerOperatorTasksListeners(listenerMiddleware.startListening);
registerOperatorRefreshListeners(listenerMiddleware.startListening);
registerOperatorDispatchListeners(listenerMiddleware.startListening);
registerOperatorKitsListeners(listenerMiddleware.startListening);
registerOperatorPackingListeners(listenerMiddleware.startListening);
registerStockSyncListeners(listenerMiddleware.startListening);
